const nameSpace = 'admin/request'

export const actions = {
  FETCH_COUNT: `${nameSpace}/FETCH_COUNT`,
  FETCH_MAP_REPORT_COUNT: `${nameSpace}/FETCH_MAP_REPORT_COUNT`,
  RESET: `${nameSpace}/RESET`,
}

export const getters = {
  requestCount: `${nameSpace}/requestCount`,
}
